var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticStyle:{"z-index":"3"},attrs:{"width":"100","height":"100","elevation":"1","rounded":"circle"}},[_c('img',{staticStyle:{"max-width":"100%"},attrs:{"src":require("../../../../assets/logo.svg"),"alt":"logo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }